import { LitElement, html, css } from 'lit';
import { nothing } from 'lit';
import { accessibility, grid, details, dialog } from '../../utilities/styles';
import { cardLinks } from '../../utilities/accessibility';
import { EventManager } from '../../utilities/events';
import { cache } from 'lit/directives/cache.js';
import { processLocationData } from '../../utilities/locationUtilities';
import { web, address, provisionIcon, phone, email, yellowTick, expandIcon, collapseIcon, arrowBack, deleteIcon } from '../../utilities/icons';
import { AllInLocationListingsConsumer } from '../Utilities/AllInLocationLIstingsConsumer';
import { handle403s } from '../../utilities/AllInErrorHandling';
import { AllInSessionStorage } from '../Utilities/AllInSessionStorage';
export class AllInLocation extends AllInSessionStorage(LitElement) {
    static properties = {
        name: { type: String },
        organisation: { type: String },
        location: { type: String },
        preview: { type: String },
        locationData: { type: Array },
        action: { type: String },
        nonce: { type: String },
        restUrl: { type: String },
        allProvisions: { type: Array },
        _locData: { state: true, type: Array },
        _draftLocData: { state: true, type: Array },
        _provisionData: { state: true, type: Array },
        _selectedImage: { state: true, type: String },
        _currentLocation: { state: true, type: String },
        _currentLocationSidebar: { state: true, type: String },
        membership: { type: Object },
        _showShareModal: { state: true, type: Boolean },
        _isSharingProfile: { state: true, type: Boolean },
        memberAlreadySharedProfileText: { type: String },
        memberShareButtonTextForLocation: { type: String },
        memberShareModalTextForLocation: { type: String },
        _eventSearch: { state: true, type: String },
        config_hardlinks: { type: Object, reflect: true },
        hardlinks: { type: Object, state: true },
    };
    constructor() {
        super();
        this._showShareModal = false;
        this._isSharingProfile = false;
    }
    async connectedCallback() {
        super.connectedCallback();
        const urlParams = new URLSearchParams(window.location.search);
        this._eventSearch = urlParams.get('eventsearch');
        this.eventManager = new EventManager(this);
        this.eventManager.listen(`allin-navigation-${this.name}`, this._updateSidebar.bind(this));
        if (this.config_hardlinks) {
            this.hardlinks = this.config_hardlinks;
        }
        this.config_hardlinks = null;
        if (!this.locationData || this.locationData.length == 0) {
            if (this.preview) {
                await this._fetchLocation();
                await this._fetchProvisions();
            }
            else {
                await this._fetchPublicLocation();
            }
        }
        if (!this.preview && !this.allProvisions) {
            this.maybeFetchAllProvisionsFromLocalStorage();
            if (!this.allProvisions) {
                await this._fetchAllProvisions();
            }
        }
        this._setLocationData();
        if (!this._selectedImage) {
            this._selectedImage = 'photo1';
        }
        cardLinks(this.shadowRoot);
    }
    firstUpdated() {
    }
    updated(changedProperties) {
        if (changedProperties.has('_locData')) {
            this._setSidebar();
            if (!this.preview) {
                this.eventManager.emit(`allin-header-${this.name}`, { name: this.name, text: `${this.locationData.name}` });
                this._setDocumentTitle(this.locationData.name);
            }
            ;
        }
        cardLinks(this.shadowRoot);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.eventManager.disconnect();
    }
    /* updated(changedProperties){

    } */
    get _modal() {
        return this.shadowRoot.querySelector('dialog');
    }
    render() {
        let mobileaside;
        let main = '';
        if (!this._locData || this._locData.length == 0) {
            main = html `<allin-loader loading></allin-loader>`;
        }
        else {
            let locData = this._locData;
            let notice = '';
            if (this._draftLocData && this._draftLocData.length > 0) {
                locData = this._draftLocData;
                notice = html `<p class="message">This preview is still awaiting approval.</p>`;
            }
            let loop = [];
            let images = [locData.find((item) => item.name == this._selectedImage), locData.find((item) => item.name == 'photo1'), locData.find((item) => item.name == 'photo2'), locData.find((item) => item.name == 'photo3')];
            images = images.filter((item) => item && item.value);
            if (images.length > 0) {
                if (images.length == 2) {
                    images = [images[0]];
                }
                images.forEach((image, i) => {
                    if (i == 0) {
                        loop.push(html `\n                            <div class="item grid--featured">\n                                <div class="image-container">\n                                    <img src="${image.value.publicUrl}" alt="${image.value.altText}" />\n                                    <allin-alt-block description="${image.value.altText}" uid="alt_${i}"></allin-alt-block>\n                                </div>\n                            </div>`);
                    }
                    else {
                        loop.push(html `\n                            <div class="card item grid--image ${image.name == this._selectedImage ? 'selected' : ''}">\n                                <img src="${image.value.publicUrl}" alt="${image.value.altText}"/>\n                                <a href="#" class="card_target" @click=${(e) => { e.preventDefault(); this._selectedImage = image.name; }}>\n                                    <span class="screen-reader-text">View ${image.name}></span>\n                                </a>\n                            </div>`);
                    }
                });
            }
            let description = locData.find((item) => item.name == 'description');
            let name = locData.find((item) => item.name == 'name');
            let text = html `\n                <h2>About ${name?.value}</h2><allin-markdown-editor readonly value="${description?.value}"></allin-markdown-editor>`;
            let provisionsLoop = [];
            if (Array.isArray(this._provisionData) && this._provisionData.length > 0) {
                provisionsLoop = this._provisionData?.map((item) => {
                    let markup = [];
                    item.provisions.forEach((provision) => {
                        markup.push(html `\n                               \n                                <div class="provision item grid grid--icon">\n                                    <div class="icon">${yellowTick}</div>\n                                    <div class="text">\n                                        <p><strong>${provision.name}</strong></p>\n                                        <allin-markdown-editor readonly value="${provision.description}"></allin-markdown-editor>\n                                        ${provision.image ? html `<img width="200" height="130" src="${provision.image}" alt="${provision.alt}" />` : ''}\n                                        ${provision.photo ? html `<img width="200" height="130" src="${provision.photo.publicUrl}" alt="${provision.photo.altText}" />` : ''}\n                                    </div>\n                                </div>\n                                    \n                            `);
                    });
                    if (markup.length == 0) {
                        return '';
                    }
                    let icon = item.title.toLowerCase().replace(/\s+/g, '_').replace(/[^\w]/g, '') + '.svg';
                    return html `\n                         <details class="provisions">\n                            <summary><img src="/wp-content/themes/ace/assets/icons/purple/${icon}" alt="Icon representing ${item.title}" @error=${(e) => { if (e.target.src !== "/wp-content/themes/ace/assets/icons/purple/default_provision.svg") {
                        e.target.src = '/wp-content/themes/ace/assets/icons/purple/default_provision.svg';
                    } }} />${item.title}</summary>\n                            <div class="panel">\n                                ${markup}\n                            </div>\n                        </details>\n                        `;
                });
            }
            let hasProvisions = provisionsLoop.filter((item) => item != '');
            let provisionsPre = '';
            if (hasProvisions.length == 0) {
                provisionsPre = html `<p class="small">No provisions have been added to this location yet</p>`;
            }
            else {
                provisionsPre = html `<div class="collapsers">\n\t\t\t\t\t<button class="expand_all" @click=${this._expandCollapseAll}>${expandIcon}Expand all</button>\n\t\t\t\t\t<button class="collapse_all" @click=${this._expandCollapseAll}>${collapseIcon}Collapse all</button>\n\t\t\t\t</div>`;
            }
            mobileaside = html `<div class="mobile-aside">${this._currentLocationSidebar}</div>`;
            console.log(this.location);
            console.log(this.locationData);
            main = html `\n                ${notice}\n                <div class="location">\n                    <div class="image-grid">${loop}</div>\n                    <div class="location_text">\n                        ${text}\n                    </div>\n                    <aside class="sidebar mobile-sidebar">${mobileaside}</aside>\n                    <div class="bg">\n                        <h2>Relevant access information</h2>\n                        ${provisionsPre}\n                        ${provisionsLoop}  \n                    </div>\n                </div>\n                <dialog>\n                    <button class="close" autofocus @click=${this._handleShareProfile}><span aria-hidden="true">${deleteIcon}</span>Cancel</button>\n                    ${this._isSharingProfile ? html `\n                        <div class="loading" aria-live="polite">\n                            <span class="loading_message">Please wait. Sharing</span>\n                        </div>\n                    ` : html `\n                        <p>${this.memberShareModalTextForEvent || `You are about to share your details with ${this.locationData?.organisation?.name}.`}</p>\n                        <button class="btn" @click=${this._cancelShareProfile}>Cancel</button>\n                        <button class="btn" @click=${this._confirmShareProfile}>Confirm</button>\n                    `}\n                </dialog>\n            `;
        }
        return html `${main}\n        `;
    }
    _updateSidebar(e) {
        this._currentLocationSidebar = e.detail.sidebar;
    }
    _handleGoBack() {
        this._currentLocation = '';
        this._currentLocationSidebar = '';
    }
    _selectLocation(location) {
        this._currentLocation = location;
    }
    async _fetchLocation() {
        let url = `${this.restUrl}?org_id=${this.organisation}&action=${this.action}-location&location_id=${this.location}nonce=${this.nonce}`;
        try {
            let response = await fetch(url, {
                headers: {
                    'AllIn-Nonce': this.nonce,
                }
            });
            //show logged out modal if session has expired
            if (response.status === 403) {
                handle403s();
                return;
            }
            let data = await response.json();
            if (data.location) {
                this.locationData = data.location;
            }
            else {
                this.locationData = data;
            }
            this.eventManager.emit(`allin-location-setter-${this.name}`, this.locationData);
        }
        catch (error) {
            console.error('Error:', error);
        }
        ;
    }
    async _fetchProvisions() {
        let url = `${this.restUrl}?org_id=${this.organisation}&action=${this.action}-provisions&location_id=${this.location}&nonce=${this.nonce}`;
        try {
            let response = await fetch(url, {
                headers: {
                    'AllIn-Nonce': this.nonce,
                }
            });
            //show logged out modal if session has expired
            if (response.status === 403) {
                handle403s();
                return;
            }
            let data = await response.json();
            this.provisionData = data.provisions;
        }
        catch (error) {
            console.error('Error:', error);
        }
        ;
    }
    maybeFetchAllProvisionsFromLocalStorage() {
        let allProvisions = this._getSessionStorageItem('allin_location_listings_provisions');
        if (allProvisions) {
            this.allProvisions = JSON.parse(allProvisions);
        }
    }
    async _fetchAllProvisions() {
        try {
            const response = await fetch(`${this.restUrl}?action=get_all_provisions`, {
                headers: {
                    'AllIn-Nonce': this.nonce,
                    'AllIn-Public': 'public',
                }
            });
            //show logged out modal if session has expired
            if (response.status === 403) {
                handle403s();
                return;
            }
            const data = await response.json();
            if (data) {
                this.allProvisions = data.provisions ?? [];
                this._setSessionStorageItem('allin_location_listings_provisions', JSON.stringify(this.allProvisions));
            }
        }
        catch (error) {
            console.error('Error fetching all provisions:', error);
        }
    }
    async _fetchPublicLocation() {
        try {
            const response = await fetch(`${this.restUrl}?action=get_location&location_id=${this.location}`, {
                headers: {
                    'AllIn-Nonce': this.nonce,
                    'AllIn-Public': 'public',
                }
            });
            //show logged out modal if session has expired
            if (response.status === 403) {
                handle403s();
                return;
            }
            let data = await response.json();
            if (!data.location) {
                this.locationData = data;
            }
            else {
                this.locationData = data.location;
            }
            this.eventManager.emit(`allin-location-setter-${this.name}`, this.locationData);
            let crumb = {
                listing: { url: `/listings/locations/`, title: `Locations` },
                panel: { url: `/listings/locations/${this.location}`, title: this.locationData.name }
            };
            this.eventManager.emit(`allin-breadcrumb-${this.name}`, crumb);
        }
        catch (error) {
            console.error('Error:', error);
        }
    }
    async _setLocationData() {
        if (this.preview) {
            let processedData = processLocationData(this.locationData);
            if (processedData) {
                ({ locData: this._locData, draftLocData: this._draftLocData, provisionData: this._provisionData } = processLocationData(this.locationData));
            }
            else {
                this.location = {};
                this._updateContext({ location: this.location });
            }
        }
        else {
            let provisions = this.locationData?.provisions ?? [];
            let locDataNoProvisions = this.locationData;
            if (locDataNoProvisions.hasOwnProperty('provisions')) {
                delete locDataNoProvisions.provisions;
            }
            let newlocData = {};
            newlocData.name = locDataNoProvisions.name;
            newlocData.location_data = locDataNoProvisions;
            ({ locData: this._locData } = processLocationData(newlocData));
            this._provisionData = this.allProvisions.map((item) => {
                let newProv = { title: item.title, provisions: [] };
                item.provisions.forEach((provision) => {
                    let provId = provision.id;
                    let existingProvision = provisions.find((prov) => prov.standardId == provId);
                    if (existingProvision) {
                        existingProvision.name = provision.name;
                        newProv.provisions.push(existingProvision);
                    }
                });
                return newProv;
            });
        }
    }
    _setSidebar() {
        let locData = this._locData;
        if (this._draftLocData && this._draftLocData.length > 0) {
            locData = this._draftLocData;
        }
        let loop = [];
        let hasSchemes = false;
        let schemeStr = html `<div class="item text"><p><strong>Accepted schemes</strong></p></div>`;
        let websiteD = locData.find((item) => item.name == 'website');
        if (websiteD.value) {
            loop.push(html `<div class="grid grid--icon">\n                    <div class="icon">${web}</div>\n                    <div class="icon_text">\n                        <h3><strong>Website:</strong></h3>\n                        <p><a href="${websiteD.value}" target="_blank">${websiteD.value}</a></p>\n                    </div>\n                </div>`);
        }
        let addressD = [
            locData.find((item) => item.name == 'address1'),
            locData.find((item) => item.name == 'address2'),
            locData.find((item) => item.name == 'city'),
            locData.find((item) => item.name == 'country'),
            locData.find((item) => item.name == 'postcode')
        ];
        if (addressD[0].value) {
            loop.push(html `<div class="item grid grid--icon">\n                    <div class="icon">${address}</div>\n                    <div class="text">\n                        <h3><strong>Address:</strong></h3>\n                        <address>\n                        ${addressD.map(item => html `<p>${item.value}</p>`)}\n                        </address>\n                    </div>\n                </div>`);
        }
        let phoneD = locData.find((item) => item.name == 'phone');
        if (phoneD.value) {
            loop.push(html `<div class="grid grid--icon">\n                    <div class="icon">${phone}</div>\n                    <div class="text">\n                        <h3><strong>Phone:</strong></h3>\n                        <p>${phoneD.value}</p>\n                    </div>\n                </div>`);
        }
        let emailD = locData.find((item) => item.name == 'email');
        if (emailD.value) {
            loop.push(html `<div class="grid grid--icon">\n                    <div class="icon">${email}</div>\n                    <div class="text">\n                        <h3><strong>Access email:</strong></h3>\n                        <p>${emailD.value}</p>\n                    </div>\n                </div>`);
        }
        /* let alreadyShared = this.membership?.organisationShares?.some(share=>share.organisationId===this.organisation);
        if(this.membership && !alreadyShared){
            loop.push(html`
                <div class="item text">
                    <p><button class="link-btn" @click=${(e) => this._handleShareProfile(e)}>${this.memberShareButtonTextForLocation || msg(`Share profile`)}</button></p>
                </div>
            `);
        }
        if(this.membership && alreadyShared){
            loop.push(html`
                <div class="item text">
                    <p><a href="/dashboard/share"><strong>${this.memberAlreadySharedProfileText || msg(`You have shared your details with this organisation`)}</strong></a></p>
                </div>
            `);
        } */
        let accessInformationD = locData.find((item) => item.name == 'accessInformation');
        if (accessInformationD.value) {
            loop.push(html `<div class="item text">\n                    <p><a href="${accessInformationD.value}" target="_blank"><strong>Access information</strong></a></p>\n                </div>`);
        }
        let videoUrlD = locData.find((item) => item.name == 'videoUrl');
        let videoDescriptionD = locData.find((item) => item.name == 'videoDescription');
        if (videoUrlD.value) {
            loop.push(html `<div class="item text">\n                    <p><a href="${videoUrlD.value}" target="_blank"><strong>Familiarisation tour</strong></a></p>\n                    ${videoDescriptionD.value ? html `<p>${videoDescriptionD.value}</p>` : ''}\n                </div>`);
        }
        let visualStoryD = locData.find((item) => item.name == 'visualStory');
        if (visualStoryD.value) {
            loop.push(html `<div class="item text">\n                    <p><a href="${visualStoryD.value}" target="_blank"><strong>Visual story</strong></a></p>\n                </div>`);
        }
        let euansGuideD = locData.find((item) => item.name == 'euansGuide');
        if (euansGuideD.value) {
            loop.push(html `<div class="item text">\n                    <img src="/wp-content/themes/ace/assets/euans.svg" alt="Euan's guide logo" width="100" height="50" />\n                    <p><a href="${euansGuideD.value}" target="_blank">Euan's Guide profile</a></p>\n                </div>`);
        }
        let accessAbleD = locData.find((item) => item.name == 'accessAble');
        if (accessAbleD.value) {
            loop.push(html `<div class="item text">\n                    <img src="/wp-content/themes/ace/assets/accessAble.png" alt="AccessAble logo" width="100" height="50" />\n                    <p><a href="${accessAbleD.value}" target="_blank">AccessAble profile</a></p>\n                </div>`);
        }
        let requiresProofOfEligibilityD = locData.find((item) => item.name == 'requiresProofOfEligibility');
        if (requiresProofOfEligibilityD.value) {
            loop.push(html `<div class="item text">\n                    <p><strong>Requires proof of eligibility:</strong></p>\n                    <p>${yellowTick}Yes</p>\n                </div>`);
        }
        let allInSchemeD = locData.find((item) => item.name == 'allInScheme');
        if (allInSchemeD.value) {
            if (!hasSchemes) {
                loop.push(schemeStr);
                hasSchemes = true;
            }
            loop.push(html `<div class="item text">\n                    <p>${yellowTick}All In</p>\n                </div>`);
        }
        let acceptNimbusCardD = locData.find((item) => item.name == 'acceptNimbusCard');
        if (acceptNimbusCardD.value) {
            if (!hasSchemes) {
                loop.push(schemeStr);
                hasSchemes = true;
            }
            loop.push(html `<div class="item text">\n                    <p>${yellowTick}Access Card</p>\n                </div>`);
        }
        let acceptCeaCardD = locData.find((item) => item.name == 'acceptCeaCard');
        if (acceptCeaCardD.value) {
            if (!hasSchemes) {
                loop.push(schemeStr);
                hasSchemes = true;
            }
            loop.push(html `<div class="item text">\n                    <p>${yellowTick}CEA Card</p>\n                </div>`);
        }
        let acceptSunflowerLanyardD = locData.find((item) => item.name == 'acceptSunflowerLanyard');
        if (acceptSunflowerLanyardD.value) {
            if (!hasSchemes) {
                loop.push(schemeStr);
                hasSchemes = true;
            }
            loop.push(html `<div class="item text">\n                    <p>${yellowTick}Sunflower Lanyards</p>\n                </div>`);
        }
        if (this.preview == "true") {
            this.eventManager.emit(`allin-navigation-${this.name}`, {
                navigation: [[
                        { title: `Go back to editing`, url: `#`, id: `organisation-dashboard`, callback: this._handleGoBack.bind(this), icon: 'arrowBack' },
                    ]],
                currentPage: '/',
                sidebar: html `\n                    <div class="sidebar preview">${loop}</div>\n                `
            });
        }
        else {
            this.eventManager.emit(`allin-navigation-${this.name}`, {
                navigation: [],
                currentPage: '/',
                sidebar: html `\n                    <div class="sidebar">\n                        <h2 class="screen-reader-text">Location information</h2>\n                        ${loop}\n                        <div class="return">\n                            <a href="#" @click=${this._handleGoBackToSearch}><span aria-hidden="true">${arrowBack}</span>Go back to search</a>\n                        </div>\n                    </div>\n                `
            });
        }
    }
    _handleShareProfile(e = false) {
        if (e) {
            e.preventDefault();
        }
        if (this._modal.open) {
            this._modal.close();
        }
        else {
            this._modal.showModal();
        }
    }
    _cancelShareProfile(e = false) {
        this._handleShareProfile(e);
    }
    async _confirmShareProfile() {
        this._isSharingProfile = true;
        try {
            const response = await fetch(this.restUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'AllIn-Nonce': this.nonce,
                },
                body: JSON.stringify({
                    action: 'member-dashboard-add-shared-org',
                    org_to_add: this.organisation
                })
            });
            if (response.status === 403) {
                handle403s();
                return;
            }
            const data = await response.json();
            if (data.error) {
                this._isSharingProfile = false;
                console.error('Error sharing profile:', data.error);
                return;
            }
            if (data.ok) {
                if (data.action_links) {
                    window.location.href = data.action_links;
                }
                else {
                    this._isSharingProfile = false;
                    this._handleShareProfile();
                }
                this.membership = {
                    ...this.membership,
                    organisationShares: [
                        ...(this.membership.organisationShares || []),
                        {
                            organisationId: this.organisation
                        }
                    ]
                };
                this._setSidebar();
            }
        }
        catch (error) {
            this._isSharingProfile = false;
            console.error('Error sharing profile:', error);
        }
    }
    _handleGoBackToSearch(e) {
        e.preventDefault();
        // if(document.referrer.includes('events')){
        //     window.history.go(-2);
        //     return;
        // }
        if (this._eventSearch) {
            // use hardlinks
            window.location.href = `${this.hardlinks.listings_events}?${this._eventSearch}`;
            return;
        }
        this.eventManager.emit(`allin-location-go-back-${this.name}`, { hide: true });
    }
    _expandCollapseAll(e) {
        e.preventDefault();
        let targets = this.shadowRoot.querySelectorAll('.provisions');
        if (e.currentTarget.classList.contains('expand_all')) {
            targets.forEach(target => {
                target.setAttribute('open', '');
            });
        }
        else {
            targets.forEach(target => {
                target.removeAttribute('open');
            });
        }
    }
    _setDocumentTitle(title) {
        document.title = `${title} - All In`;
    }
    static styles = [
        accessibility,
        grid,
        details,
        dialog,
        css `
        :host{
            width:100%;
        }
        .bg{
            padding:var(--allin-padding,2rem);
            background-color:var(--allin-bg-color,#ccc);
            display:grid;
            gap:1rem;
        }
        .small{
            font-size:0.875rem;
        }

        .grid{
            gap:1.5rem;
        }
        h2{
            font-size:1.5rem;
            color:var(--allin-highlight-color,#472961);
        }
        .image-grid{
            display: flex;
            flex-wrap: wrap;
            gap: 1rem;
            container-type: inline-size;
        }

        .grid--featured{
            flex-basis: 100%;
            background-color: transparent;
            max-height: 450px;
            line-height: 0;
        }
        .image-container{
            position: relative;
            max-height: 450px;
            width: fit-content;
            margin: 0 auto;
            overflow-x: clip;
        }
        .grid--image {
            flex-shrink: 1;
            flex-grow: 0;
            flex-basis: 0;
            height: 150px;
        }

        .grid--featured img{
            width: 100%;
            height: 100%;
            object-fit: contain;
            object-position: top;
            line-height: 0;
            max-height: 450px;
        }
        .grid--image img{
            width: auto;
            height: 100%;
            object-fit: cover;
            /* object-position: top; */
            max-width: calc(33cqw - 0.67rem);
        }

        .grid--image.selected{
            outline: 4px solid var(--allin-secondary-color,#FFCE58);
        }
        .provisions{
            background-color:#fff;
            border-radius:0.4rem;
            border:1px solid #707070;
            padding:0;
            margin-bottom:1rem;
        }
        .provisions summary{
            padding:1rem 1rem;
            margin:0;
            font-size:1.25rem;
            font-weight:700;
            color:var(--allin-highlight-color,#472961);
            cursor:pointer;
            display: flex;
            align-items: center;
            gap: 1.5rem;
        }
        .provisions summary img{
            object-fit:contain;
            object-position:top left;
            width:24px;
        }
        .provisions summary::after{
            right:1rem;
            top:1.2rem;
        }
        .provisions .panel{
            padding:0.5rem 1rem;
        }
        input:read-only:not([type=submit]) {
            background-color: #fff;
        }
        .provisions summary img{
            object-fit:contain;
            object-position:top left;
            width:24px;
        }
        .provisions img{
            object-fit:contain;
            object-position:top left;
        }
        .collapsers{
            margin-right:auto;
            margin-bottom:1rem;
            display: flex;
            gap: 1rem;
            width: fit-content;
        }
        .collapsers button{
            background-color: transparent;
            color: var(--allin-highlight-color,#472961);
            border: 0;
            cursor: pointer;
            font-weight: 700;
            font-size: 1rem;
            display: flex;
            align-items: center;
            gap: 0.5rem;
        }

        .grid--icon {
            grid-template-columns: 1.6rem 1fr;
            gap: 1.5rem;
            margin-bottom: 1rem;
            width: 100%;
        }

        /** Mobile sidebard to show up only below 999px */
        aside.sidebar.mobile-sidebar{
            display: none;
            padding: 2.5rem 0;
            max-width: 300px;
        }
        .mobile-sidebar .grid--icon {
            margin-bottom: unset;
            border-bottom: 1px solid var(--allin-border-color, #707070);
            padding: 1rem 0;
        }
        .mobile-sidebar .grid--icon svg{
            width: 1.6rem;
            height: auto;
        }
        .mobile-sidebar .grid--icon svg path{
            fill: var(--allin-highlight-color, #472961);
        }
        .mobile-sidebar p{
            margin: 0;
        }
        .mobile-sidebar .grid--icon p strong{
            color: var(--allin-regular-text-color, #1a1a1a);
        }
        .mobile-sidebar a{
            color: var(--allin-text-color, #472961);
            text-decoration: underline;
            font-weight: 600;
            white-space: normal;
            overflow-wrap: break-word;
            word-break: break-word;
            display: inline;
        }
        .mobile-sidebar .return a{
            font-size: 1.25rem;
            font-weight: 700;
        }
        .mobile-sidebar .grid--icon+.item.text {
            padding-top: 1rem;
        }
        .mobile-sidebar .item.text {
            padding: 0 0 1rem;
        }
        .mobile-sidebar .return{
            padding: 0;
            margin-bottom: 2rem;
        }

        p{
            margin-top:0;
        }

        .provisions summary::after {
            right: 1rem;
            top: 1.2rem;
        }

        .share-modal {
            position: fixed;
            inset: 0;
            z-index: 99999;
            display: flex;
            align-items: center;
            justify-content: center;
            background: rgba(0,0,0,.5);
        }

        .share-modal-content {
            background: white;
            padding: 0rem;
            max-width: 500px;
            width: calc(100% - 2rem);
            position: relative;
            z-index: 100000;
        }

        .share-modal-content:not(:has(.loading)){
            padding: 2rem;
        }

        .loading {
            display: flex;
            gap: 0.5rem;
            align-items: center;
            justify-content: center;
            padding: 2rem;
            background-color: var(--allin-bg-color,#ccc);
            min-height: 20rem;
            margin: 0;
        }

        .loading::after {
            content: "";
            display: block;
            width: 2rem;
            height: 2rem;
            animation: 1s linear 0s infinite normal none running spin;
            z-index: 100;
            background-image: url("/wp-content/themes/ace/assets/wheel.svg");
            background-size: cover;
        }

        @keyframes spin {
            from {
                transform: rotate(0deg);
            }
            to {
                transform: rotate(360deg);
            }
        }

        button.btn {
            padding: 1rem;
            border-radius: var(--allin-border-radius, 0.5rem);
            width: fit-content;
            text-align: center;
            font-family: var(--allin-font-family, Montserrat, sans-serif);
            font-size: var(--allin-font-size, 1rem);
            color: var(--allin-button-text-color, #fff);
            font-weight: (var(--allin-button-font-weight, 600));
            cursor: pointer;
            border: none;
            background: var(--allin-button-bg-color, #472961);
            transition: background var(--transition) ease;
        }
        button.btn:hover{
            background: var(--color-secondary-lighter-to-primary-lighter, #d3c9d7);
            color: rgb(52,52,52);
        }
        button{
            border:none;
        }

        @media screen and (max-width: 999px) {
            aside.sidebar.mobile-sidebar{
                display: block;
            }
        }
        `
    ];
}
